import type { ReactNode } from 'react';
import { ThemeProvider as LegacyThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider } from '@mui/material/styles';
import { legacyMuiTheme } from './legacyMuiTheme';
import { muiTheme } from './muiTheme';

/**
 * Mounts both MUI generations' themes. They live in separate contexts - v4 in JSS's, v9 in emotion's -
 * so nesting them changes no style injection order; each generation just stops using its built-in
 * default palette.
 */
export const AppThemeProvider = ({ children }: { children: ReactNode }) => (
  <LegacyThemeProvider theme={legacyMuiTheme}>
    <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>
  </LegacyThemeProvider>
);
